export default class UserCancelledError extends Error {
}
